import React from "react";
import CompanySettings from "../../views/CompanySettings";

const CompanySettingsPage = () => {
  return <CompanySettings />;
};

export default CompanySettingsPage;
